import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42fb6f59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "project",
  class: "flex justify-center items-center"
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "lg:text-7xl text-4xl font-black text-center lg:mt-24 my-12 text-[#163537] dark:text-gray-200" }, " Projects ")
], -1))
const _hoisted_3 = { class: "card-grid grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8" }
const _hoisted_4 = { class: "p-4 py-2" }
const _hoisted_5 = {
  key: 0,
  class: "w-full h-80"
}
const _hoisted_6 = ["src", "onLoad", "onError"]
const _hoisted_7 = { class: "p-4 pt-6" }
const _hoisted_8 = { class: "sm:text-xl text-base font-bold mb-2 h-8" }
const _hoisted_9 = { class: "font-light text-[#163537] dark:text-gray-300 sm:text-base text-sm mb-4 pb-6 lg:h-32 md:h-48 h-36" }
const _hoisted_10 = { class: "mb-4 text-gray-700 dark:text-gray-300" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Stack: ", -1))
const _hoisted_12 = { class: "flex justify-between border-b-2 dark:border-gray-700 pb-6 items-center text-[#ccc] dark:text-gray-500" }
const _hoisted_13 = {
  key: 0,
  class: "flex justify-start gap-3 items-center border-2 border-r-4 border-b-4 border-[#163537] dark:border-gray-500 shadow-md shadow-[#333] dark:shadow-gray-900 hover:shadow-none bg-transparent dark:bg-transparent font-light py-2 px-6 rounded-md text-black dark:text-gray-300 text-sm cursor-pointer"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-3 text-gray-600 dark:text-gray-400"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
  })
], -1))
const _hoisted_16 = {
  key: 1,
  class: "flex justify-start gap-3 items-center border dark:border-gray-600 hover:shadow-none bg-transparent font-light py-2 px-6 rounded-md text-black dark:text-gray-400 text-sm cursor-not-allowed"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Github", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-3"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
  })
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "flex justify-start gap-3 items-center border-2 border-r-4 border-b-4 border-[#163537] dark:border-gray-500 shadow-[#333] dark:shadow-gray-900 shadow-md hover:shadow-none bg-transparent font-light py-2 px-6 rounded-md text-black dark:text-gray-300 text-sm cursor-pointer" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-3 text-gray-600 dark:text-gray-400"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
  })
], -1))

import { ref, onMounted } from "vue";
import SkeletonLoader from "./SkeletonLoader.vue";
import eso from "../assets/eso.png";
import attica from "../assets/attica.png";
import fun from "../assets/fun.png";
import gen6ixx from "../assets/gen6ixx.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectComp',
  setup(__props) {

const imageLoading = ref<Record<number, boolean>>({
  0: true,
  1: true,
  2: true,
  3: true,
});

// Preload images
onMounted(() => {
  const images = [eso, attica, fun, gen6ixx];
  images.forEach((img, index) => {
    const image = new Image();
    image.src = img;
    image.onload = () => {
      imageLoading.value[index] = false;
    };
    image.onerror = () => {
      imageLoading.value[index] = false;
    };
  });
});

const cards = [
  {
    image: eso,
    title: "ESO Security Training Platform",
    description:
      "A comprehensive security training platform with Admin CMS.This platform provides robust security training solutions/certification with a full-featured content management system for administrators.",
    github: "/",
    live: "https://esotrainingnw.co.uk/",
    stack: "ReactJs,Framer, NodeJs, TailwindCss, CMS Integration",
  },
  {
    image: attica,
    title: "AtticaHQ Real Estate Platform",
    description:
      "A sophisticated real estate platform with Admin CMS for product listings, featuring AI-powered capabilities. AtticaHQ offers advanced property management tools and intelligent features to enhance the real estate experience.",
    github: "/",
    live: "https://atticahq.com/",
    stack: "ReactJs, NodeJs, TailwindCss, AI Integration, CMS",
  },
  {
    image: fun,
    title: "FunNTail Official Website",
    description:
      "The official website for FunNTail. A modern, responsive web presence showcasing the company's services and portfolio with an engaging user experience.",
    github: "/",
    live: "https://funntail.co.uk",
    stack: "ReactJs,NodeJs,Framer, TailwindCss, Modern UI/UX",
  },
  {
    image: gen6ixx,
    title: "Gen6ixx Official Website",
    description:
      "The official website for Gen6ixx, developed to showcase the company's innovative solutions and expertise. Built with modern web technologies to deliver a professional and engaging digital experience.",
    github: "/",
    live: "https://gen6ixx.com/",
    stack: "ReactJs,NodeJs,Framer,, TailwindCss, Modern UI/UX",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "w-fit rounded-md overflow-hidden border shadow-md bg-white dark:bg-gray-800 dark:border-gray-700"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (imageLoading.value[index])
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(SkeletonLoader, {
                    type: "image",
                    "image-class": "w-full h-80 rounded-t-md"
                  })
                ]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: card.image,
                  alt: "Card Image",
                  onLoad: ($event: any) => (imageLoading.value[index] = false),
                  onError: ($event: any) => (imageLoading.value[index] = false),
                  class: "card-image w-full h-80 object-contain lg:object-cover border dark:border-gray-700 rounded-t-md hover:scale-105"
                }, null, 40, _hoisted_6))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(card.title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(card.description), 1),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(card.stack), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (card.github != '/')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: card.github,
                      class: ""
                    }, "Github", 8, _hoisted_14),
                    _hoisted_15
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  href: card.live,
                  class: "",
                  target: "_blank"
                }, "Live", 8, _hoisted_21),
                _hoisted_22
              ])
            ])
          ])
        ])
      }), 64))
    ]),
    _createVNode(_component_router_link, {
      to: "/projects",
      class: "cursor-pointer font-bold my-6 block text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400"
    }, {
      default: _withCtx(() => [
        _createTextVNode("See More Projects ...")
      ]),
      _: 1
    })
  ]))
}
}

})